<template lang="pug">
  div.confirm-layout
    div.alert.alert-success
      span 此藥物總存量:  {{ selectedDrugTotalAmount }}
      span.float-right 
    RxCheckBarcode(
      v-if="currentProgress === 'rxCheck'"
      v-on:confirmRx="confirmRx"
    )
    ActionWrap(
      v-if="currentProgress === 'actionWrap'"
      v-on:setActionData="getFetchData"
      :actionProgress="actionProgress"
      :amount="currentDrug.amount"
      :barcodeData="barcodeData"
      :schedules="schedules"
      :summarySelectedMed="summarySelectedMed"
      :reviewer="reviewer"
    )

</template>

<script>
import ActionWrap from './ActionWrap';
import ConfirmFlowBase from '../ComponentBase/ConfirmFlowBase';
import RxCheckBarcode from '../flowComp/RxCheckBarcode';


export default {
  name: 'ConfirmFlow',
  extends: ConfirmFlowBase,
  props: ['schedules', 'summarySelectedMed'],
  data() {
    return {
      barcodeData: {},
      reviewer: undefined,
    };
  },
  components: {
    ActionWrap,
    RxCheckBarcode,
  },
  created() {
    this.$store.dispatch('getDrugInDevicesWithSameDrug', this.currentDrug.med.id);
  },
  computed: {
  },
  methods: {
    getFetchData(data) {
      this.$emit('confirmationFinish');
    },
    confirmRx(reviewer) {
      this.reviewer = reviewer;
      this.nextProgress();
    },
  },
};
</script>




// WEBPACK FOOTER //
// ConfirmFlow.vue?4a90db8b